import axios from 'axios';
import KDBush from 'kdbush'
import geokdbush from 'geokdbush'
// https://opengeo.tech/maps/gpx-simplify-optimizer/

var index = null 
var kpts = [];
// TODO: dynamic URL
// axios.get('https://movingobject.co/keknap21teszt/data/indexpoints.json')
//axios.get('https://movingobject.co/keknap22teszt/data/okk_szakasz_143_0912_46180nodes-100m-points.json')
axios.get('https://movingobject.co/keknap22teszt/data/okk_szakasz_143_0912_30031nodes-230m-points.json')
.then( response => {
  kpts = response.data.indexpoints
  index = new KDBush(kpts, (p) => p[0], (p) => p[1]); // lon, lat
})
.catch( error => {
  console.log(error)
})


// 47: latitude, 21: longitude
export function isPointNearby(lon, lat, thresholdKm) {
  if (! index) return  false 
  // lon, lat, maxResults, maxDistance: kms
  // console.log(index)
  var nearest = geokdbush.around(index, lon, lat, 1, thresholdKm)[0];
  // distance in kms: 
  //if (nearest !== undefined) console.log( geokdbush.distance(nearest[0], nearest[1], lon, lat) )
  //if (nearest !== undefined) console.log(
  //  lat, ", ", lon, "-->", nearest[1], nearest[0], 
  //  geokdbush.distance(lon, lat, nearest[0], nearest[1]), thresholdKm
  //)
  //else console.log('OUT')
  return (nearest !== undefined && nearest.length > 0 )
}
